import classnames from 'classnames/bind'
import { GlobalGridPreset } from '~/@types/grid-preset'

import RightColumnRow, {
  RowProps,
} from '~/components/UI/TwoColumnsLayout/RightColumnRow'

import { useStyle } from '~/providers/StyleProvider'

import css from './styles.module.scss'

const cx = classnames.bind(css)
export const TwoColumnsLayoutsTypes = {
  HALVES: 'halves',
  THIRDS: 'thirds',
} as const

type TwoColumnsLayoutsTypes =
  typeof TwoColumnsLayoutsTypes[keyof typeof TwoColumnsLayoutsTypes]

export type TwoColumnsLayoutProps =  {
  className?: string
  leftColumnClassName?: string
  rightColumnClassName?: string
  leftColumnComponents?: JSX.Element[]
  rightColumnComponents?: RowProps[]
  layout: TwoColumnsLayoutsTypes
}

function TwoColumnsLayout({
  className,
  leftColumnClassName,
  rightColumnClassName,
  leftColumnComponents,
  rightColumnComponents,
  layout,
}: TwoColumnsLayoutProps) {
  const content = rightColumnComponents?.map((row, index) => (
    <RightColumnRow className={cx(css.row)} key={`row_${index}`} {...row} />
  ))

  const gridStyle = useStyle({ grid: GlobalGridPreset.BASE_GRID })
  return (
    <div
      className={cx(css.TwoColumnsLayout, className, gridStyle, css?.[layout])}>
      {leftColumnComponents && (
        <div
          className={cx(css.leftColumn, leftColumnClassName, {
            empty: leftColumnComponents?.length === 0,
          })}>
          {leftColumnComponents}
        </div>
      )}
      {rightColumnComponents && (
        <div className={cx(css.rightColumn, rightColumnClassName)}>
          {content}
        </div>
      )}
    </div>
  )
}

TwoColumnsLayout.defaultProps = {}

export default TwoColumnsLayout
